import { v4 as uuidv4 } from "uuid";

const state = {
  notifications: [],
  blockNewNotifications: false,
};

const getters = {
  errors: (state) => {
    return state.notifications.filter(
      (notification) => notification.type === "error",
    );
  },
};

const actions = {
  addError({ commit }, notification) {
    if (state.blockNewNotifications) {
      return;
    }
    notification["type"] = "error";
    notification["id"] = uuidv4();
    commit("ADD_NOTIFICATION", notification);
  },
  addSuccess({ commit }, notification) {
    if (state.blockNewNotifications) {
      return;
    }
    notification["type"] = "success";
    notification["id"] = uuidv4();
    commit("ADD_NOTIFICATION", notification);
  },
  addWarning({ commit }, notification) {
    if (state.blockNewNotifications) {
      return;
    }
    notification["type"] = "warning";
    notification["id"] = uuidv4();
    commit("ADD_NOTIFICATION", notification);
  },
  addErrorForce({ commit }, notification) {
    notification["type"] = "error";
    notification["id"] = uuidv4();
    commit("ADD_NOTIFICATION", notification);
  },
  deleteNotification({ commit }, id) {
    commit("DELETE_NOTIFICATION", id);
  },
  clean({ commit }) {
    console.log("Nettoyage des notifications");
    commit("CLEAN");
  },
};

const mutations = {
  ADD_NOTIFICATION(state, notification) {
    state.notifications.push(notification);
  },
  DELETE_NOTIFICATION(state, id) {
    state.notifications = state.notifications.filter(
      (notif) => notif.id !== id,
    );
  },
  CLEAN(state) {
    state.notifications = [];
  },
  BLOCK_NOTIFICATIONS(state) {
    state.blockNewNotifications = true;
  },
  UNBLOCK_NOTIFICATIONS(state) {
    state.blockNewNotifications = false;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
